import React from 'react';
import '../styles/Coprosec.css';

/*Documentos COPROSEC*/
import Plan_pdf from '../documentos/coprosec/PLAN_ACCION_DE_SEGURIDAD_CIUDADANA_2024-2027.pdf';
import Resolucion_pdf from '../documentos/coprosec/RESOLUCION_DE_ALCALDIA_053-2023-A-MPCH.pdf';
import Directorio_pdf from '../documentos/coprosec/DIRECTORIO_COPROSEC_2024.pdf';
import ActaConsulta_I_2023_pdf from '../documentos/coprosec/ACTA_I_CONSULTA_PUBLICA_2023.pdf';
import ActaConsulta_I_2024_pdf from '../documentos/coprosec/ACTA_I_CONSULTA_PUBLICA_2024.pdf';
import ActaConsulta_II_2024_pdf from '../documentos/coprosec/ACTA_II_CONSULTA_PUBLICA_2024.pdf';
import ActaConsulta_III_2024_pdf from '../documentos/coprosec/ACTA_III_CONSULTA_PUBLICA_2024.pdf';
import ActaConsulta_IV_2024_pdf from '../documentos/coprosec/ACTA_IV_CONSULTA_PUBLICA_2024.pdf';
import ActaConsulta_I_2025_pdf from '../documentos/coprosec/ACTA_I_CONSULTA_PUBLICA_2025.pdf';
import ActaConsulta_III_2025_pdf from '../documentos/coprosec/ACTA_III_CONSULTA_PUBLICA_2025.pdf';
import ActaO_I_2024_pdf from '../documentos/coprosec/ACTA_I_SESION_ORDINARIA_2024.pdf';
import ActaO_II_2024_pdf from '../documentos/coprosec/ACTA_II_SESION_ORDINARIA_2024.pdf';
import ActaO_IV_2024_pdf from '../documentos/coprosec/ACTA_IV_SESION_ORDINARIA_2024.pdf';
import ActaO_V_2024_pdf from '../documentos/coprosec/ACTA_V_SESION_ORDINARIA_2024.pdf';
import ActaO_VI_2024_pdf from '../documentos/coprosec/ACTA_VI_SESION_ORDINARIA_2024.pdf';
import ActaO_I_2025_pdf from '../documentos/coprosec/ACTA_I_SESION_ORDINARIA_2025.pdf';
import ActaO_II_2025_pdf from '../documentos/coprosec/ACTA_II_SESION_ORDINARIA_2025.pdf';
import ActaO_IV_2025_pdf from '../documentos/coprosec/ACTA_IV_SESION_ORDINARIA_2025.pdf';
import ActaO_V_2025_pdf from '../documentos/coprosec/ACTA_V_SESION_ORDINARIA_2025.pdf';
import ActaX_II_2024_pdf from '../documentos/coprosec/ACTA_II_SESION_EXTRAORDINARIA_2024.pdf';
import Evaluacion_I_2024_pdf from '../documentos/coprosec/EVALUACION_I_TRIMESTRE_2024.pdf';
import Evaluacion_II_2024_pdf from '../documentos/coprosec/EVALUACION_II_TRIMESTRE_2024.pdf';
import Evaluacion_III_2024_pdf from '../documentos/coprosec/EVALUACION_III_TRIMESTRE_2024.pdf';
import Evaluacion_IV_2024_pdf from '../documentos/coprosec/EVALUACION_IV_TRIMESTRE_2024.pdf';
import Evaluacion_I_2025_pdf from '../documentos/coprosec/EVALUACION_I_TRIMESTRE_2025.pdf';
import Evaluacion_III_2025_pdf from '../documentos/coprosec/EVALUACION_III_TRIMESTRE_2025.pdf';

/*Iconos*/
import pdf_icon from '../imagenes/icons/pdf.gif';

function Coprosec(){
  return(
    <>
      <Directorio/>
      <RenderPdfs/>
      <VistaPDF/>
    </>
  );
};
export default Coprosec;

function VistaPDF(){
  return(
    <div className="pdf-container">
      <h2>Plan de Acción de Seguridad Ciudadana Chumbivilcas 2024-2027</h2>

      {/* Vista previa en iframe */}
      <iframe
        src={Plan_pdf}
        title="Vista previa PDF"
        className="pdf-iframe"
      ></iframe>

      {/* Botón para abrir en nueva pestaña */}
      <a
        href={Plan_pdf}
        target="_blank"
        rel="noopener noreferrer"
        className="pdf-boton"
      >
        Ver documento completo
      </a>
    </div>
  );
};

function Directorio(){
  const integrantes = [
    {
      numero: 1,
      nombre: 'Sr. Froilan Batallanos Ibarra',
      institucion: 'Municipalidad Provincial de Chumbivilcas',
      cargo: 'Presidente',
    },
    {
      numero: 2,
      nombre: 'ABOG. Tania Monge Zúniga',
      institucion: 'Suprefecta Provincial',
      cargo: 'Integrante',
    },
    {
      numero: 3,
      nombre: 'CAP. PNP Jaime Doroteo Ipanaque',
      institucion: 'Comisaria Rural PNP Santo tomas',
      cargo: 'Integrante',
    },
    {
      numero: 4,
      nombre: 'Dra. Eva Rosa Valle Prieto',
      institucion: 'UGEL Chumbivilcas',
      cargo: 'Integrante',
    },
    {
      numero: 5,
      nombre: 'M.C. Guillermo L. Vilca Cáceres',
      institucion: 'Unidad Ejecutora 411-Red salud Chumbivilcas',
      cargo: 'Integrante',
    },
    {
      numero: 6,
      nombre: 'Abg. Manuel Percy Chihuantito Aragón',
      institucion: 'Ministerio Publico Chumbivilcas',
      cargo: 'Integrante',
    },
    {
      numero: 7,
      nombre: 'Abg. Néstor Piérola Ilaccaña',
      institucion: 'Juzgado Mixto Chumbivilcas',
      cargo: 'Integrante',
    },
    {
      numero: 8,
      nombre: 'Ing. Julián Domínguez Mendoza',
      institucion: 'Municipalidad Distrital Velille',
      cargo: 'Integrante',
    },
    {
      numero: 9,
      nombre: 'Prof. Santos Oviedo Ataucuri',
      institucion: 'Municipalidad Distrital de Colquemarca',
      cargo: 'Integrante',
    },
    {
      numero: 10,
      nombre: 'Lic. Richar Bellido Ugarte',
      institucion: 'Municipalidad Distrital de Livitaca',
      cargo: 'Integrante',
    },
    {
      numero: 11,
      nombre: 'Sr. Guzmán Romero Fernández',
      institucion: 'Juntas Vecinales Santo tomas',
      cargo: 'Integrante',
    },
    {
      numero: 12,
      nombre: 'Sr. David Zuvizarreta Mollo',
      institucion: 'Rondas Campesinas Chumbivilcas',
      cargo: 'Integrante',
    }, 
  ];
  return(
    <div className="directorio-container">
      <h1>COPROSEC 2024</h1>
      <h2>Directorio de los Integrantes de COPROSEC Chumbivilcas 2023–2026</h2>
      <table className="directorio-tabla">
        <thead>
          <tr>
            <th>N°</th>
            <th>Nombre</th>
            <th>Inst. que representa</th>
            <th>Cargo</th>
          </tr>
        </thead>
        <tbody>
          {integrantes.map((item) => (
            <tr key={item.numero}>
            <td>{item.numero}</td>
            <td>{item.nombre}</td>
            <td>{item.institucion}</td>
            <td>{item.cargo}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

function RenderPdfs(){
  const documentos = [
    /*{
      titulo: 'Resolución de Alcaldía',
      url: Resolucion_pdf,
    }, 
    {
      titulo: 'Directorio COPROSEC 2024',
      url: Directorio_pdf,
    },
    {
      titulo: 'Acta I de Consulta Pública - 2023',
      url: ActaConsulta_I_2023_pdf,
    }, 
    {
      titulo: 'Acta I Sesión Ordinaria - 2024',
      url: ActaO_I_2024_pdf,
    }, 
    {
      titulo: 'Acta II Sesión Ordinaria - 2024',
      url: ActaO_II_2024_pdf,
    }, 
    {
      titulo: 'Acta I de Consulta Pública - 2024',
      url: ActaConsulta_I_2024_pdf,
    }, 
    {
      titulo: 'Evaluación I Trimestre - 2024',
      url: Evaluacion_I_2024_pdf,
    },
    {
      titulo: 'Evaluación II Trimestre - 2024',
      url: Evaluacion_II_2024_pdf,
    },
    {
      titulo: 'Acta II de Consulta Pública - 2024',
      url: ActaConsulta_II_2024_pdf,
    }, 
    {
      titulo: 'Acta II Sesión Extraordinaria - 2024',
      url: ActaX_II_2024_pdf,
    }, 
    {
      titulo: 'Acta IV Sesión Ordinaria - 2024',
      url: ActaO_IV_2024_pdf,
    },
    {
      titulo: 'Acta V Sesión Ordinaria - 2024',
      url: ActaO_V_2024_pdf,
    },
    {
      titulo: 'Acta III de Consulta Pública - 2024',
      url: ActaConsulta_III_2024_pdf,
    }, 
    {
      titulo: 'Evaluación III Trimestre - 2024',
      url: Evaluacion_III_2024_pdf,
    },
    {
      titulo: 'Acta IV de Consulta Pública - 2024',
      url: ActaConsulta_IV_2024_pdf,
    }, 
    {
      titulo: 'Acta VI Sesión Ordinaria - 2024',
      url: ActaO_VI_2024_pdf,
    },
    {
      titulo: 'Evaluación IV Trimestre - 2024',
      url: Evaluacion_IV_2024_pdf,
    },*/
    {
      titulo: 'Acta I Sesión Ordinaria - 2025',
      url: ActaO_I_2025_pdf,
    },
    {
      titulo: 'Acta II Sesión Ordinaria - 2025',
      url: ActaO_II_2025_pdf,
    },
    {
      titulo: 'Acta I de Consulta Pública - 2025',
      url: ActaConsulta_I_2025_pdf,
    }, 
    {
      titulo: 'Evaluación I Trimestre - 2025',
      url: Evaluacion_I_2025_pdf,
    },
    {
      titulo: 'Acta III de Consulta Pública - 2025',
      url: ActaConsulta_III_2025_pdf,
    },
    {
      titulo: 'Acta IV Sesión Ordinaria - 2025',
      url: ActaO_IV_2025_pdf,
    },
    {
      titulo: 'Acta V Sesión Ordinaria - 2025',
      url: ActaO_V_2025_pdf,
    },
    {
      titulo: 'Evaluación III Trimestre - 2025',
      url: Evaluacion_III_2025_pdf,
    },
  ];
  return(
    <div className="galeria-container">
      <h2>Documentos Públicos</h2>
      <div className="pdf-grid">
        {documentos.map((doc, index) => (
          <div className="pdf-card" key={index}>
            <img src={pdf_icon} className="pdf-icon"></img>
            <h3>{doc.titulo}</h3>
            <a
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              className="ver-btn"
            >
              Ver Documento
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
